<template>
  <div class="content">
    <el-input v-model="queryParams.name" placeholder="名称" clearable style="width: 210px"></el-input>
    <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
    <el-button type="primary" icon="el-icon-refresh" @click="resetForm">重置</el-button>
    <el-button type="primary" size="medium" icon="el-icon-plus" @click.native="add">新增</el-button>
    <div class="table" style="margin-top: 10px">
      <el-table :data="tableData" border v-loading="loading">
        <el-table-column prop="id" label="序号" align="center"></el-table-column>
        <el-table-column prop="name" label="卡源名称" align="center"></el-table-column>
        <el-table-column prop="operationName" label="运营商" align="center"></el-table-column>
        <el-table-column prop="remark" label="备注" align="center"></el-table-column>
        <el-table-column prop="channel" label="渠道编码" align="center"></el-table-column>
        <el-table-column prop="status" label="状态" align="center">
            <template slot-scope="{row}">
              <el-tag v-if="row.status =='1'">启用</el-tag>
              <el-tag v-else type="warning">停用</el-tag>
            </template>
        </el-table-column>
        <el-table-column prop="type" label="类型" align="center"></el-table-column>
        <el-table-column label="操作" align="center" width="150" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" icon="el-icon-edit" type="text" @click="handleUpdate(scope.row)" >编辑</el-button>
            </template>
          </el-table-column>
      </el-table>
    </div>
    <div class="block" style="margin-top: 30px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <!-- 添加或者修改卡源 -->
    <el-dialog :title="title" :visible.sync="open" width="600px" append-to-body :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
          <el-form-item label="卡源名称" prop="name">
            <el-input v-model="form.name" placeholder="请输入卡源名称" maxlength="30" />
          </el-form-item>
          <el-form-item label="运营商">
            <el-select v-model="form.operationName" placeholder="请选择类型" :disabled="disabled">
            <el-option
                  v-for="dict in operationName"
                  :key="dict.key"
                  :label="dict.value"
                  :value="dict.key"
                ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item  label="渠道编码" prop="channel">
            <el-input v-model="form.channel" :disabled="disabled" placeholder="请输入渠道编码" maxlength="30" />
          </el-form-item>
          <el-form-item  label="状态" >
            <el-radio-group v-model="form.status">
              <el-radio
                v-for="dict in sourceStatus"
                :key="dict.key"
                :label="dict.key"
              >{{dict.value}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item  label="类型" >
            <el-select v-model="form.type" placeholder="请选择类型">
            <el-option
                  v-for="dict in type"
                  :key="dict.key"
                  :label="dict.value"
                  :value="dict.key"
                ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="form.remark" type="textarea" placeholder="请输入内容"></el-input>
          </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import { cardSourceList,getCardSource,addCardSource,updateCardSource } from "@/api/api.js"; //获取卡源列表
export default {
  name: "source",
  data() {
    return {
      // 遮罩层
      loading: true,
      // 搜索
      queryParams:{},
      page: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      //是否可以编辑
      disabled:false,
      // 表单参数
      form: {},
      operationName:[
        {key:'中国移动',value:'中国移动'},
        {key:'中国电信',value:'中国电信'},
        {key:'中国联通',value:'中国联通'}
        ],
      //状态
      sourceStatus:[
        {key:'1',value:'启用'},
        {key:'0',value:'停用'}
      ],
      //类型
      type:[
        {key:'1',value:'操作开关机'},
        {key:'2',value:'操作网络状态'}
      ],
      rules: {
        name: [
          { required: true, message: "用户名称不能为空", trigger: "blur" },
          { min: 2, max: 20, message: '用户名称长度必须介于 2 和 20 之间', trigger: 'blur' }
        ],
        operationName: [
          { required: true, message: "运营商不能为空", trigger: "blur" }
        ],
        channel: [
          { required: true, message: "渠道编码不能为空", trigger: "blur" }
        ],
      }
    };
  },
  computed: {},
  methods: {
    // 获取列表
    initData() {
      let params = {
        model:{
          ...this.queryParams,
        },
        page: this.page,
        pageSize: this.pageSize
      };
      this.loading = true;
      cardSourceList(params).then(res => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
          this.loading = false;
        }else{
          this.$message.error("加载时间过长，请重新请求！");
          this.loading = false;
        }
      });
    },
    search(){
      this.page = 1,
      this.initData();
    },
    resetForm(){
      for (var i in this.queryParams) {
        this.queryParams[i] = null;
      };
      this.initData();
    },
    //表单重置
    reset(){
      this.form = {
        name: undefined,
        operationName: undefined,
        channel: undefined,
        status: '1',
        remark: undefined,
      };
      this.resetForm("form");
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      const id = row.id;
      getCardSource({
        id:id
      }).then(response => {
        this.form = response.data.data;
        this.open = true;
        this.title = "修改卡源";
        this.disabled = true;
      });
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.initData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.initData();
    },
    add(){
      this.reset();
      this.title = "新增卡源";
      this.open = true;
      this.disabled = false;
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.search();
    },
    // 弹窗的x
    dialogClose(){
      this.$refs.form.clearValidate();
      this.dialog = false;
    },
    /** 提交按钮 */
    submitForm: function() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.id != undefined) {
            updateCardSource(this.form).then(response => {
              this.$message.success("修改成功");
              this.open = false;
              this.search();
            });
          } else {
            addCardSource(this.form).then(response => {
              this.$message.success("新增成功");
              this.open = false;
              this.search();
            });
          }
        }
      });
    },
  },
  mounted() {
  },
  created(){
    this.initData();
  }
};
</script>
<style scoped lang="less">
.el-button {
  margin-left: 5px;
  border-radius: 3px;
  padding: 10px 20px;
}
</style>


